module.exports = __webpack_public_path__ + "img/Bank-Bukopin.812e1d3e.jpg";